import { Link } from "gatsby";
import React from "react";
import { useLocation } from "@reach/router";
import { toSentenceCase } from "../utils/text";

const SidebarMenu = (props) => {

	const location = useLocation();

	return (
		<aside className="h-fit w-full flex-none md:w-56 lg:w-64">
			<h2 className="text-[9px] font-extrabold uppercase tracking-eyebrow text-muted">Categorías</h2>
			<hr className="mb-5 mt-3 border-line" />

			<nav aria-label="Categorías">
				{
					props.items.map((item, index) => {
						const href = `/categoria/${item.categorySlug}`;
						const isActive = location.pathname === href;

						return (
							<Link
								to={ href }
								key={ index }
								className={ `block py-2 text-sm transition-colors duration-200 hover:text-brand ${isActive ? "font-bold text-brand-deep" : "text-ink-soft"}` }
							>
								{ toSentenceCase(item.category) }
							</Link>
						);
					})
				}
			</nav>
		</aside>
	);
};

export default SidebarMenu;
